import alert_mixin from '@/utils/mixins/alert_mixin';
import manage_document_methods from './manage_documents_methods';

export default {
  name: 'ManageDocuments',
  mixins: [alert_mixin],
  data: () => ({
    search_query: '',
    current_page: 1,
    page_size: 4,
    loading: false,
    assigning_rule: false,
    assigning_transition_rule: false,
    updating_document_rule_id: '',
    loading_rule_documents: false,
    loading_rules: false,
    loading_transition_rules: false,
    loading_forms: false,
    loading_documents: false,
    forms: [],
    document_form_summaries: [],
    rules: [],
    transition_rules: [],
    assigned_rule_documents: [],
    all_rule_documents: [],
    bulk_selected_rule_id: '',
    bulk_selected_transition_rule_id: '',
    selected_form_id: '',
    selected_document_ids: [],
    documents: [],
    selected_document: null
  }),
  computed: {
    selected_form() {
      return this.selectable_forms.find((form) => String(form.id) === String(this.selected_form_id)) || null;
    },
    selected_form_summary() {
      return this.document_form_summaries.find((form) => String(form.id) === String(this.selected_form_id)) || null;
    },
    compliance_rule_placeholder() {
      if (this.loading_rules) {
        return 'Loading compliance rules...';
      }

      return this.rules.length
        ? 'Select compliance rule'
        : 'No compliance rules available';
    },
    transition_rule_placeholder() {
      if (this.loading_transition_rules) {
        return 'Loading transitions...';
      }

      return this.transition_rules.length
        ? 'Select transition rule'
        : 'No transition rules available';
    },
    selectable_forms() {
      return this.forms.filter((form) => this.is_document_form(form));
    },
    has_selected_form() {
      return Boolean(this.selected_form_id);
    },
    document_form_count() {
      return this.document_form_summaries.length;
    },
    total_document_fields() {
      return this.document_form_summaries.reduce((total, form) => total + Number(form.document_count || 0), 0);
    },
    selected_document_count() {
      return this.selected_document_ids.length;
    },
    assigned_rule_document_count() {
      return this.assigned_rule_documents.length;
    },
    assigned_rule_section_question_ids() {
      return new Set(
        this.assigned_rule_documents
          .map((document) => Number(document.section_question_id))
          .filter((id) => Number.isInteger(id) && id > 0)
      );
    },
    all_rule_section_question_ids() {
      return new Set(
        this.all_rule_documents
          .map((document) => Number(document.section_question_id))
          .filter((id) => Number.isInteger(id) && id > 0)
      );
    },
    filtered_documents() {
      const query = String(this.search_query || '').toLowerCase().trim();
      const documents = this.documents;

      if (!query) return documents;

      return documents.filter((document) => {
        const haystack = `${document.name} ${document.description} ${document.type} ${document.section_name} ${document.form_name}`.toLowerCase();
        return haystack.includes(query);
      });
    },
    total_pages() {
      const pages = Math.ceil(this.filtered_documents.length / this.page_size);
      return Math.max(1, pages);
    },
    paginated_documents() {
      const start = (this.current_page - 1) * this.page_size;
      const end = start + this.page_size;
      return this.filtered_documents.slice(start, end);
    },
    all_visible_documents_selected() {
      return this.paginated_documents.length > 0
        && this.paginated_documents.every((document) => this.selected_document_ids.includes(String(document.section_question_id)));
    },
    pagination_label() {
      const total = this.filtered_documents.length;
      if (!total) return '0 of 0 results';

      const start = (this.current_page - 1) * this.page_size + 1;
      const end = Math.min(this.current_page * this.page_size, total);
      return `${start} to ${end} of ${total} results`;
    }
  },
  watch: {
    search_query() {
      this.current_page = 1;
    },
    selected_form_id() {
      this.current_page = 1;
      this.search_query = '';
      this.selected_document = null;
      this.selected_document_ids = [];
      this.bulk_selected_rule_id = '';
      this.bulk_selected_transition_rule_id = '';
      this.rules = [];
      this.assigned_rule_documents = [];
      this.all_rule_documents = [];
      this.transition_rules = [];
      this.fetch_documents_for_selected_form();
    },
  },
  mounted() {
    this.fetch_forms();
  },
  methods: manage_document_methods
};

